import React from 'react';
import "./index.scss"
import { useSelector } from 'react-redux';


export default function Footer() {

    const { copyright, recordNumber } = useSelector(state => state.siteInfo)

    return (
        <div
            className='footer-container '
        >
            <span> {copyright}</span>
            <span> 版权所有：黄山有农创新农业科技公司</span>
            <span>网站备案： <a href="https://beian.miit.gov.cn/"
                target="_blank">
                {recordNumber}</a></span>

        </div>
    )
}
